// TODO: this file should replace commons/index.js
export { default as UIComponent } from './UIComponent';
export {
  default as asBaseComponent,
  BaseComponentInjectedProps,
} from './asBaseComponent';
export { default as forwardRef, ForwardRefInjectedProps } from './forwardRef';
export {
  default as withScrollEnabler,
  WithScrollEnablerProps,
} from './withScrollEnabler';
export {
  default as withScrollReached,
  WithScrollReachedProps,
} from './withScrollReached';
export {
  ContainerModifiers,
  MarginModifiers,
  TypographyModifiers,
  ShadowsModifiers,
  ColorsModifiers,
  BackgroundColorModifier,
} from './modifiers';
